import convert from 'convert';

/**
 * Convert units
 * Note: this could also be useful to have on the GraphQL
 * @param {object} props
 * @param {string | number} props.value - value to convert
 * @param {string} props.from - source unit
 * @param {string} props.to - target unit
 * @returns {{value: number, unit: string}}
 */
export default function convertUnits({ value, from, to }) {
  if (!value) return {};
  if (isNaN(parseFloat(value))) return {};
  // If the units are the same, don't convert
  if (from === to)
    return {
      value,
      unit: from,
    };

  return {
    value: convert(parseFloat(value), from).to(to),
    unit: to,
  };
}
